import { useState } from "react";
import { Fragment } from "react/jsx-runtime";
import { FormFields } from "./components/FormFields";
import { ExpandMore } from "@mui/icons-material";
import clsx from "clsx";
import { isFieldVisible } from "../../../../utils/form";
import { softenCaps } from "../../../../utils/classification";

interface Props {
  values: any;
  setValues: any;
  handleFormItem: any;
  secondForm: any;
}

function countRequired(form: any, values: any) {
  const required = (form.campos ?? []).filter(
    (campo: any) => campo.obrigatorio && isFieldVisible(campo, values)
  );
  const filled = required.filter((campo: any) => {
    const key = campo.chave || campo.Chave;
    const value = values[key];
    return Array.isArray(value) ? value.length > 0 : !!value;
  });
  return { required: required.length, filled: filled.length };
}

export default function SecondStep(props: Props) {
  const { values, handleFormItem, secondForm, setValues } = props;
  const [selectedForm, setSelectedForm] = useState<number>();

  const totals = secondForm.reduce(
    (acc: { required: number; filled: number }, form: any) => {
      const count = countRequired(form, values);
      acc.required += count.required;
      acc.filled += count.filled;
      return acc;
    },
    { required: 0, filled: 0 }
  );

  return (
    <>
      <p className="mx-auto my-6 max-w-3xl text-center text-sm leading-relaxed text-muted">
        Abra cada categoria, preencha os indicadores e avance. Campos com{" "}
        <span className="font-bold text-red">*</span> são obrigatórios.
      </p>
      {totals.required > 0 && (
        <p
          className="mb-4 text-center text-sm font-semibold tabular-nums text-gray"
          aria-live="polite"
        >
          {totals.filled}/{totals.required} indicadores obrigatórios preenchidos
        </p>
      )}

      <div className="flex flex-col gap-3">
        {secondForm.map((form: any, index: any) => {
          const { required, filled } = countRequired(form, values);
          const isOpen = selectedForm === index;

          return (
            <Fragment key={`form-${index}`}>
              <button
                type="button"
                className={clsx(
                  "flex w-full items-center justify-between rounded-xl border px-4 py-3 text-left font-semibold transition-colors",
                  isOpen
                    ? "border-primary bg-primaryLight text-primary"
                    : "border-border bg-white text-gray hover:border-primary/40"
                )}
                onClick={() =>
                  setSelectedForm((previousIndex) =>
                    previousIndex === index ? undefined : index
                  )
                }
                aria-expanded={isOpen}
              >
                <span className="min-w-0 pr-3">
                  <span className="block truncate">{softenCaps(form.titulo)}</span>
                  {required > 0 && (
                    <span className="mt-0.5 block text-xs font-medium tabular-nums text-muted">
                      {filled}/{required} obrigatórios
                    </span>
                  )}
                </span>
                <ExpandMore
                  className={clsx(
                    "shrink-0 transition-transform",
                    isOpen && "rotate-180"
                  )}
                  aria-hidden="true"
                />
              </button>

              {isOpen && (
                <FormFields
                  form={form}
                  handleFormItem={handleFormItem}
                  setValues={setValues}
                  values={values}
                />
              )}
            </Fragment>
          );
        })}
      </div>
    </>
  );
}
